<div class="breadcrum">
  <a (click)="navigate(breadCrumData.previousUrl)">
      <em class="icon-Back previousArrow"></em>
      <h1>{{breadCrumData.previousPage}}</h1>
      <em class="icon-RightArrow forwardArrow"></em>
  </a>
  <span>{{breadCrumData.currentPage}}</span>
</div>
